import { NovaLogo } from "@nova/component-icons"
import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { TryAddOnItemColorfinder } from "./components/TryAddOnItemColorfinder"
import { TryAddOnItemOrthomosaic } from "./components/TryAddOnItemOrthomosaic"
import { TryAddOnItemHotspots } from "./components/TryAddOnItemHotspots"
import { TryAddOnItemVideo } from "./components/TryAddOnItemVideo"
import { TryAddOnItemPanorama } from "./components/TryAddOnItemPanorama"
import { useAppDispatch } from "integrations/redux/hooks"
import { hideGlobalModal } from "runlevel/actions"

export const TryOurAddOnsModal = () => {
    const dispatch = useAppDispatch()
    return (
        <HighPriorityNovaModalContainer
            title="Welcome to Nova"
            icon={NovaLogo}
            closeModal={() => dispatch(hideGlobalModal())}
            className="w-[21.75rem]"
        >
            <div className="mt-4 select-none">
                <h2 className="text-gray-0 font-normal">Try our Add-ons</h2>
                <h5 className="text-gray-300 mt-2 mb-6">
                    Try our powerful add-ons for free with our pre-loaded sample data.
                </h5>
                <div className="flex flex-col gap-2">
                    <TryAddOnItemOrthomosaic />

                    <TryAddOnItemHotspots />

                    <TryAddOnItemColorfinder />

                    <TryAddOnItemVideo />

                    <TryAddOnItemPanorama />
                </div>
            </div>
        </HighPriorityNovaModalContainer>
    )
}
